import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './product-details.component'

let module = angular.module('productDetails', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('vehicle.productDetails', {
      url: '/product/:ref',
      params: { group: null },
      component: 'productDetails',
      authenticate: true
    })
})

.component('productDetails', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/product-details/index.js